import React, { useState } from 'react'
import PropTypes from 'prop-types'
import { useMutation } from '@apollo/client'
import { useTranslation } from 'react-i18next'
import { Button, Upload } from 'antd'
import { UploadOutlined } from '@ant-design/icons'

import { initActiveStorageBlobs } from '../../helpers/directUpload'
import { DELETE_ACTIVE_STORAGE_BLOB_MUTATION } from './graphql'

const ACCEPT = 'image/*,application/pdf'

const uploadedBlobIds = fileList => fileList
  .filter(file => file.status === 'done' && file.response && file.response.id)
  .map(file => `${file.response.id}`)

const BlobUploader = ({ onChange, onBusyChange }) => {
  const { t } = useTranslation('loanAgreements')
  const [fileList, setFileList] = useState([])
  const [deleteBlobs] = useMutation(DELETE_ACTIVE_STORAGE_BLOB_MUTATION)

  const handleChange = ({ fileList: nextFileList }) => {
    setFileList(nextFileList)
    onChange(uploadedBlobIds(nextFileList))
    onBusyChange(nextFileList.some(file => file.status === 'uploading'))
  }

  const handleRemove = (file) => {
    if (file.response && file.response.id) {
      deleteBlobs({ variables: { blobIds: [`${file.response.id}`] } })
    }
  }

  const customRequest = ({ file, onSuccess, onError }) => {
    initActiveStorageBlobs([file], {
      onSuccess: blob => onSuccess(blob),
      onError: () => onError(new Error('upload failed'))
    })

    return { abort () {} }
  }

  return (
    <Upload
      accept={ACCEPT}
      customRequest={customRequest}
      fileList={fileList}
      listType='picture'
      multiple
      onChange={handleChange}
      onRemove={handleRemove}
    >
      <Button icon={<UploadOutlined />}>{t('upload')}</Button>
    </Upload>
  )
}

BlobUploader.propTypes = {
  onBusyChange: PropTypes.func,
  onChange: PropTypes.func
}

BlobUploader.defaultProps = {
  onBusyChange: () => {},
  onChange: () => {}
}

export default BlobUploader
